import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Movies from "@/pages/movies/page";
import MovieDetail from "@/pages/movie-detail/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news-detail/page";
import Specials from "@/pages/specials/page";
import SpecialDetail from "@/pages/special-detail/page";
import About from "@/pages/about/page";
import Search from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/movies", element: <Movies /> },
      { path: "/movie/:id", element: <MovieDetail /> },
      { path: "/news", element: <News /> },
      { path: "/news/:id", element: <NewsDetail /> },
      { path: "/specials", element: <Specials /> },
      { path: "/specials/:id", element: <SpecialDetail /> },
      { path: "/about", element: <About /> },
      { path: "/search", element: <Search /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;